angular.module('controllers').controller('roleController', ['$scope', '$rootScope', '$controller', '$mdDialog', '$http', 'Crud', '$route', '$routeParams', '$location', '$timeout',
    function ($scope, $rootScope, $controller, $mdDialog, $http, Crud, $route, $routeParams, $location, $timeout) {
        $rootScope.path = '/role';
        $rootScope.modelName = 'role';
        $scope.pathTemplate = 'users/roles';
        $scope.title = 'Roluri';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $scope.sortType = 'id';
        $scope.defaultItem = 10;
        $rootScope.typeId = 'id';
        $scope.search.order = 'asc';
        $scope.classAction = 'td-big';
        $scope.columns = {
            //'id':{'label':'Detalii', 'filter':0, 'filterType':'input'},
            'role_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
            'status':{'label':'Status', 'filter':1, 'filterType':'select'}
        };

        $scope.columns.status.options = [
            {'id':'', 'value' : ''},
            {'id':1, 'value' : 'true'},
            {'id':0, 'value' : 'false'}
        ];

        $scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);

        $scope.additionals = [];
        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'role_name';

        var selected = [];
        $scope.checkedAll = [];
        $scope.toggleAll = function (keyObject, objects) {
            if($scope.checkedAll[keyObject] == true) {
                $scope.checkedAll[keyObject] = false;
                angular.forEach(objects, function (items, index) {
                    $scope.checked[items.id] = false;
                    selected.splice(selected.indexOf(items.id), 1);
                });
            } else {
                $scope.checkedAll[keyObject] = true;
                angular.forEach(objects, function (items, index) {
                    $scope.checked[items.id] = true;
                    selected.push(items.id);
                });
            }
            selected = selected.filter (function (value, index, array) {
                return array.indexOf (value) == index;
            });
            $scope.addPermissions();
        }

       $scope.checked = [];
        $scope.toggle = function (item, keyObject, object) {
            if($scope.checked[item] == true) {
                $scope.checked[item] = false;
                selected.splice(selected.indexOf(item), 1);
            } else {
                $scope.checked[item] = true;
                selected.push(item);
            }

            selected = selected.filter (function (value, index, array) {
                return array.indexOf (value) == index;
            });

            var allTrue = [];var no= 0;
            angular.forEach(object, function (items, key) {
                if($scope.checked[items.id] === true) {
                    allTrue[no] = key;
                    no++;
                }
            });
            if (allTrue.length >= 1 && allTrue.length == object.length) {
                $scope.checkedAll[keyObject] = true;
            } else {
                $scope.checkedAll[keyObject] = false;
            }

            $scope.addPermissions();
        };

        $scope.addPermissions = function () {
            $scope.additionals['invalid'] = '';
            var post = {};
            post['permissions'] = selected;
            post['roleId'] = $scope.modelData.id;
            post['route'] = 'addPermissions';

            Crud.post('form-urlencoded', post, $scope.path + '/addPermissions')
                .success(function (data) {
                    if (!angular.isUndefined(data.invalid)) {
                        $scope.additionals['invalid'] = data.invalid;
                    }
                    $scope.errors = {};

                })
                .error(function (data) {
                    $scope.errors = data.errors;
                });
        };

        /* detail model */
        $rootScope.detailPermission = function () {

            $scope.getPermissions = function (path, offset, per_page) {
                $scope.range = [];
                $scope.itemsPerPageOptions = [
                    {id: 1, name: '1'},
                    {id: 5, name: '5'},
                    {id: 10, name: '10'},
                    {id: 25, name: '25'},
                    {id: 50, name: '50'},
                    {id: 0, name: 'All'}
                ];

                $scope.state = {};
                if (angular.isUndefined(per_page)) {
                    if (!angular.isUndefined($scope.state.itemsPerPage)) {
                        per_page = $scope.state.itemsPerPage;
                    }
                } else {
                    $scope.state.itemsPerPage = per_page;
                }
                $scope.state.page = offset;
                if ($scope.state.page > $scope.no_pages) {
                    $scope.state.page = $scope.no_pages;
                    offset = $scope.no_pages;
                }
                if (per_page == 0) {
                    $scope.state.page = 1;
                    $scope.state.itemsPerPage = 0;
                }
                if (angular.isUndefined($scope.no_pages)) {
                    $scope.no_pages = 1;
                }
                $scope.isLoading = true;
                $scope.role_id = [];
                $scope.$watch('no_pages', function (item) {
                    item = $scope.no_pages;
                }, true);

                Crud.get(path +'/getPermissions?page='+ offset +'&per_page='+ per_page)
                    .success(function (data) {
                        if (!angular.isUndefined(data.invalid)) {
                            $scope.additionals['invalid'] = data.invalid;
                        } else {
                            $scope.from = data.from;
                            $scope.to = data.to;
                            $scope.total = data.total;
                            $scope.no_pages = Math.ceil(data.total / data.per_page);

                            if (per_page == 0) {
                                $scope.range = [{}];
                            } else {
                                for (var i = 0; i < $scope.no_pages; i++) {
                                    $scope.range[i] = i;
                                }
                            }
                            $scope.models = data.data;
                            $scope.models.per_page = data.per_page;
                            $scope.models.current_page = data.current_page;
                            $scope.selected = {};
                            $scope.selectedAll = false;
                        }
                        $scope.isLoading = false;

                    });

            };
            $scope.getPermissions($scope.path, 1, $scope.defaultItem);

            Crud.show($routeParams.id, $scope.path)
                .success(function (data) {
                    $scope.modelData = data;
                    angular.forEach($scope.modelData.permissions, function (item, key) {
                        selected.push(item.id);
                        $scope.checked[item.id] = true;
                    });
                });
        };

                /* add multiple ips forms */
                $scope.additionals['ips'] = [{}];
                $scope.additionals['cloneItem'] = function(model, modelLength) {
                        var itemToClone = {};
                        $scope.additionals[model].push(itemToClone);
                }
                $scope.additionals['removeItem'] = function(itemIndex, modelIp) {

                        console.log($scope.modelData.ips)
                        if (!angular.isUndefined($scope.errors)) {
                                if (!angular.isUndefined($scope.errors['ips.' + itemIndex + '.role_client'])) {
                                        delete $scope.errors['ips.' + itemIndex + '.role_client'];
                                }
                                if (!angular.isUndefined($scope.errors['ips.' + itemIndex + '.role_ip'])) {
                                        delete $scope.errors['ips.' + itemIndex + '.role_ip'];
                                }
                        }

                        $scope.interm = [];
                        angular.forEach($scope.additionals[modelIp], function(itemy, indexy) {
                                $scope.interm[indexy] = {
                                        'role_client': itemy['role_client'],
                                        'role_ip': itemy['role_ip']
                                };
                        });
                        $scope.interms = [];
                        angular.forEach($scope.interm, function(itemyy, indexyy) {
                                $scope.interms.push({
                                        'role_client': itemyy['role_client'],
                                        'role_ip': itemyy['role_ip']
                                });
                        });
                        $scope.interms.splice(itemIndex, 1);
                        $scope.additionals[modelIp] = $scope.interms;

 console.log($scope.additionals[modelIp] )

                        $timeout(function() {
                                $scope.modelData.ips = $scope.additionals[modelIp];

                                console.log($scope.modelData.ips)
                        }, 100);

                }

            $scope.addIpsModel = function(ev, path, model) {
                        if ($scope.mode_action == 'page') {
                                $scope.controlSH = true;
                                $scope.action = 'ip';
                                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                                $scope.additionals['invalid'] = '';

                                var currentModel = {};
                                angular.forEach(model, function(item, key) {
                                        switch (key) {
                                                case 'ips':
                                                        currentModel['ips'] = [];
                                                        angular.forEach(item, function(itemIps, keyIps) {
                                                                currentModel['ips'][keyIps] = {};
                                                                angular.forEach(itemIps, function(itemIpsDetail, keyIpsDetail) {
                                                                        currentModel['ips'][keyIps][keyIpsDetail] = itemIpsDetail;
                                                                });
                                                        });
                                                        break;
                                                default:
                                                        currentModel[key] = item;
                                                        break;
                                        }
                                });
                                $scope.modelData = currentModel;
                               if (angular.isUndefined(currentModel.ips) || currentModel.ips.length == 0) {
                                        currentModel.ips = [{}];
                                }
                                $scope.additionals['ips'] = currentModel.ips;

                                $scope.cancel = function() {
                                        $scope.modelData = {};
                                        $scope.errors = {};
                                        $scope.controlSH = false;
                                };

                                $scope.addIp = function() {
                                        $scope.additionals['buttonDisabled'] = true;
                                        $scope.isLoading = true;
                                        var post = {};
                                        post['route'] = 'ip';
                                        post['ips'] = $scope.modelData['ips'];
                                        post['id'] = model['id'];
                                        Crud.post($scope.additionals['content_type'], post, path + '/ip')
                                                .success(function(data) {
                                                        if (!angular.isUndefined(data.invalid)) {
                                                                $scope.additionals['invalid'] = data.invalid;
                                                        } else {
                                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                                        $scope.additionals['functionResult'](ev, data);
                                                                }
                                                                /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                                                 $scope.selected[model[$rootScope.typeId]] = model;
                                                                 }*/
                                                                if (!angular.isUndefined(data.currentModel)) {
                                                                        if (!angular.isUndefined($scope.models)) {
                                                                                $scope.getElement($scope.models, data.currentModel);
                                                                        }
                                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                                $scope.modelData = data.currentModel;
                                                                        }
                                                                } else {
                                                                        if (!angular.isUndefined($scope.models)) {
                                                                                $scope.getElement($scope.models, currentModel);
                                                                        }
                                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                                $scope.modelData = currentModel;
                                                                        }
                                                                }
                                                        }
                                                        $scope.modelData = {};
                                                        $scope.errors = {};
                                                        $scope.isLoading = false;
                                                        $scope.controlSH = false;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                })
                                                .error(function(data) {
                                                        $scope.isLoading = false;
                                                        $scope.errors = data.errors;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                });
                                };
                        }

                        if ($scope.mode_action == 'dialog') {
                                $scope.additionals['invalid'] = '';
                                var currentModel = {};
                                angular.forEach(model, function(item, key) {
                                        switch (key) {
                                                case 'ips':
                                                        currentModel['ips'] = [];
                                                        angular.forEach(item, function(itemIps, keyIps) {
                                                                currentModel['ips'][keyIps] = {};
                                                                angular.forEach(itemIps, function(itemIpsDetail, keyIpsDetail) {
                                                                        currentModel['ips'][keyIps][keyIpsDetail] = itemIpsDetail;
                                                                });
                                                        });
                                                        break;
                                                default:
                                                        currentModel[key] = item;
                                                        break;
                                        }
                                });

                                $mdDialog.show({
                                        controller: DialogController,
                                        templateUrl: 'ipDialog.tmpl.html',
                                        parent: angular.element(document.body),
                                        targetEvent: ev,
                                        clickOutsideToClose: true,
                                        locals: {
                                                pathTemplate: $scope.pathTemplate,
                                                model: currentModel,
                                                selected: $scope.selected,
                                                additionals: $scope.additionals
                                        }
                                }).then(function() {
                                        if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                                                if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                                                $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                                                        }
                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                $scope.modelData = $scope.additionals['dataCurrentModel'];
                                                        }
                                                } else {
                                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                                                $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                                                        }
                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                $scope.modelData = currentModel;
                                                        }
                                                }

                                        }
                                });
                                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'selected', 'additionals'];
                                function DialogController($scope, $mdDialog, pathTemplate, model, selected, additionals) {
                                        $scope.pathTemplate = pathTemplate;
                                        $scope.modelData = model;
                                        $scope.additionals = additionals;
                                        $scope.selected = selected;

                                        $scope.cancel = function() {
                                                $mdDialog.cancel();
                                        };

                                        $scope.additionals['removeItem'] = function(itemIndex, modelIp) {
                                                if (!angular.isUndefined($scope.errors)) {
                                                        if (!angular.isUndefined($scope.errors['ips.' + itemIndex + '.role_client'])) {
                                                                delete $scope.errors['ips.' + itemIndex + '.role_client'];
                                                        }
                                                        if (!angular.isUndefined($scope.errors['ips.' + itemIndex + '.role_ip'])) {
                                                                delete $scope.errors['ips.' + itemIndex + '.role_ip'];
                                                        }
                                                }

                                                $scope.interm = [];
                                                angular.forEach($scope.additionals[modelIp], function(itemy, indexy) {
                                                        $scope.interm[indexy] = {
                                                                'role_client': itemy['role_client'],
                                                                'role_ip': itemy['role_ip']
                                                        };
                                                });
                                                $scope.interms = [];
                                                angular.forEach($scope.interm, function(itemyy, indexyy) {
                                                        $scope.interms.push({
                                                                'role_client': itemyy['role_client'],
                                                                'role_ip': itemyy['role_ip']
                                                        });
                                                });
                                                $scope.interms.splice(itemIndex, 1);
                                                $scope.additionals[modelIp] = $scope.interms;

                                                $timeout(function() {
                                                        $scope.modelData.ips = $scope.additionals[modelIp];
                                                }, 100);

                                        }

                                        if (angular.isUndefined($scope.modelData.ips) || $scope.modelData.ips.length == 0) {
                                                $scope.modelData.ips = [{}];
                                        }
                                        $scope.additionals['ips'] = $scope.modelData.ips;

                                        $scope.addIp = function() {
                                                $scope.isLoading = true;
                                                $scope.additionals['buttonDisabled'] = true;
                                                var post = {};
                                                post['route'] = 'ip';
                                                post['ips'] = $scope.modelData['ips'];
                                                post['id'] = $scope.modelData['id'];
                                                Crud.post($scope.additionals['content_type'], post, path + '/ip')
                                                        .success(function(data) {
                                                                if (!angular.isUndefined(data.invalid)) {
                                                                        $scope.additionals['invalid'] = data.invalid;
                                                                } else {
                                                                        if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                                                $scope.additionals['functionResult'](ev, data);
                                                                        }
                                                                        /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                                                         $scope.selected[model[$rootScope.typeId]] = model;
                                                                         }*/
                                                                        if (!angular.isUndefined(data.currentModel)) {
                                                                                $scope.additionals['dataCurrentModel'] = data.currentModel;

                                                                        }

                                                                }
                                                                $scope.isLoading = false;
                                                                $mdDialog.hide();
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        })
                                                        .error(function(data) {
                                                                $scope.isLoading = false;
                                                                $scope.errors = data.errors;
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        });
                                        };
                                }
                        }

                };
                /*end add ips*/

    }]
)
